import React, { useState, useEffect } from "react";
import api from "../../../../../../../core/services/api";
import moment from "moment";
import Chart from "react-apexcharts";
import options from "./options";

//material ui
import Grid from "@material-ui/core/Grid";

function GraphCard(props) {
  const [state, setState] = useState({
    series: [0, 0, 0],
    start_day: moment().format("YYYY-MM-DD"),
    end_day: moment().add(1, "days").format("YYYY-MM-DD"),
  });

  useEffect(() => {
    getData();
  }, [props.start_day, props.end_day, props.routes]);

  async function getData() {
    try {
      props.parentCallback(true);

      const data = await api.get(
        `/sla-report-geral?start_at=${props.start_day}&end_at=${props.end_day}&routes=[${props.routes}]`
      );
      let series = [];
      let value = data.data.data.data ? parseFloat(data.data.data.data.otd.value) : 0;
      let value_dhl = data.data.data.data ? parseFloat(data.data.data.data.otd.value_dhl_delay) : 0;
      let value_other = data.data.data.data ? parseFloat(data.data.data.data.otd.value_other_delay) : 0;
      series.push(value);
      series.push(value_dhl);
      series.push(value_other);
      setState((prev) => ({
        ...prev,
        series: series,
      }));
    } catch (error) {
      console.warn(error);
    } finally {
      props.parentCallback(false);
    }
  }

  return (
    <Grid container justify="center">
      <Grid item>
        <Chart
          options={options()}
          series={state.series}
          type="donut"
          width={320}
        />
      </Grid>
    </Grid>
  );
}

export default GraphCard;
